import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  return <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-28 overflow-hidden" data-id="element-105">
      {/* Hero Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-106">
        <img src="https://cdn.magicpatterns.com/uploads/2jrhwd6zj5tc9Es1jZ7VFR/Imagen_1.png" alt="" aria-hidden="true" className="w-full h-full object-cover object-center opacity-25" data-id="element-107" />
        <div className="absolute inset-0 bg-gradient-to-r from-teal-975 via-teal-975/90 to-teal-975/60" data-id="element-108"></div>
        <div className="absolute inset-0 bg-teal-975/40" data-id="element-109"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-110">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} className="flex flex-col items-start" data-id="element-112">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta/10 text-terracotta text-sm md:text-base font-semibold tracking-wide uppercase mb-8 border border-terracotta/20" data-id="element-113">
              <span className="w-2 h-2 rounded-full bg-terracotta" data-id="element-114"></span>
              ENTRENAMIENTO GRATUITO ONLINE + EBOOK DE REGALO
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl leading-[1.05] mb-8 text-balance text-cream font-semibold" data-id="element-115">
              Descubre las 4 áreas que el{' '}
              <span className="italic text-terracotta" data-id="element-116">apego emocional</span>{' '}
              está drenando en tu vida
            </h1>

            <p className="text-xl md:text-2xl text-cream/80 mb-10 max-w-xl leading-relaxed" data-id="element-117">
              Aprende cómo recuperar tu paz emocional, dejar de depender
              emocionalmente y volver a conectar contigo mismo.
            </p>

            <CTAButton data-id="element-118" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:h-[600px] flex items-center justify-center" data-id="element-119">
            {/* Abstract decorative background */}
            <div className="absolute inset-0 bg-terracotta/5 rounded-full blur-3xl transform -rotate-12 scale-110" data-id="element-120"></div>
            <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-gold/10 rounded-full blur-3xl" data-id="element-121"></div>

            {/* Book Cover Image — blends seamlessly into the dark background */}
            <img src="https://cdn.magicpatterns.com/uploads/4YEiofYyFhVzCHJWvkSGg7/Portada_FODA_Freddy_Pimentel_Listo.png" alt="Portada del libro Método F.O.D.A — Recupera tu Soberanía Emocional, por Freddy Pimentel" style={{
            mixBlendMode: 'lighten'
          }} className="relative z-10 w-full max-w-md scale-110 transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-122" />
          </motion.div>
        </div>
      </div>
    </section>;
}